import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { VerificationDocumentResponseViewModel, VerificationDocumentType } from 'models';
import { catchError, map } from 'rxjs/operators';

const endpointPrefix = 'api/verification-document';

@Injectable({
	providedIn: 'root',
})
export class VerificationDocumentsService {
	constructor(private http: HttpClient) {}

	getVerificationDocument(verificationId: string, verificationDocumentType: VerificationDocumentType): Observable<string | null> {
		const requestBody = {
			VerificationRequestIdentifier: verificationId,
			VerificationDocumentType: verificationDocumentType,
		};

		const headers = new HttpHeaders({
			'x-loader-interceptor': 'false', // Uses existing functionality to skip loader for document download
			'x-api-interceptor-errors': 'false',
		});

		return this.http.post<VerificationDocumentResponseViewModel>(`${endpointPrefix}/get`, requestBody, { headers }).pipe(
			map(({ base64String, contentType }: VerificationDocumentResponseViewModel) => {
				if (!base64String) return null;
				return `data:${contentType};base64,${base64String}`;
			}),
			catchError(error => {
				console.error('Document load failed:', error);
				return of(null); // Return `null` on 404/errors
			})
		);
	}
}
